/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    const MINY = feature.getSettingValue('MINY');
    const MAXY = feature.getSettingValue('MAXY');

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
dim tmp_widget as lcd_graph_widget
tmp_widget.x_pos = ${feature.getSettingValue('STARTX')}
tmp_widget.y_pos = ${feature.getSettingValue('STARTY')}
tmp_widget.width = ${feature.getSettingValue('WIDTH')}
tmp_widget.height = ${feature.getSettingValue('HEIGHT')}
tmp_widget.fill_color = ${PlatformUtils.hexToTibboColor(feature.getSettingValue('FILL'))}
tmp_widget.min_val = ${MINY}
tmp_widget.max_val = ${MAXY}
tmp_widget.background_color = &h0000
tmp_widget.foreground_color = &hffff
tmp_widget.max_points = 30
'tmp_widget.points = lcd_graph_points
lcd_graph_init(tmp_widget)

`,
    });

    return blocks;
};
